import React, {Component} from 'react';
import {connect} from 'react-redux';
import {setHav} from '../../actions';
import {getHav} from '../../utils/havCookie';

const getDisplayName = (WrappedComponent) => {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

const mapDispatchToProps = {
    setHavInState: setHav
};

const mapStateToProps = ({tripboardButton}) => ({hav: tripboardButton.auth && tripboardButton.auth.hav});

const withHav = (WrappedComponent) => {
    return connect(mapStateToProps, mapDispatchToProps)(
        class withHavWrapper extends Component {
            displayName = `withHav(${getDisplayName(WrappedComponent)})`;

            constructor(props) {
                super(props);
                this.getHavFromConfig();
            }

            componentDidUpdate() {
                this.getHavFromConfig();
            }

            getHavFromConfig() {
                const {hav, setHavInState} = this.props;
                if (!hav) {
                    const havFromConfigOrCookie = getHav();
                    setHavInState({hav: havFromConfigOrCookie});
                }
            }

            render() {
                return <WrappedComponent {...this.props} />;
            }
        }
    );
};

export default withHav;
